import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeEvery } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* fetchClassesStudents() {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/admin/reports`);
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchClassesStudentsSuccess(response.data));
      console.log("response data", response);
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchClassesStudentsError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* reviewReport(action) {
  try {
    const response = yield axios.post(
      `${baseURL}/api/v2/admin/reports`,
      action.payload
    );

    console.log("API response:", response.data.data);

    if (response.data?.success) {
      AntdAlert.success("Review report successfully");
      yield put(
        actions.reviewReportSuccess(response.data.data.classEnrolment)
      );
    } else {
      yield put(
        actions.reviewReportError(response.data.message || "Error")
      );
    }
  } catch (error) {
    AntdAlert.error("Failed to review report");
    yield put(actions.reviewReportError(error.message));
    errorHandler(error);
  }
}

export function* generateReport(action) {
  try {
    const response = yield axios.post(
      `${baseURL}/api/v2/admin/reports/generate`, 
      action.payload
    );

    if (response.data?.success) {
      AntdAlert.success("Report generated successfully");
      yield put(actions.generateReportSuccess(response.data.data));
    } else {
      yield put(
        actions.generateReportError(response.data.message || "Error")
      );
    }
  } catch (error) {
    AntdAlert.error("Failed to generate report");
    yield put(actions.generateReportError(error.message));
    errorHandler(error);
  }
}

export function* watcherSemesterReportSaga() {
  yield takeEvery(constants.FETCH_CLASSES_STUDENTS, fetchClassesStudents);
  yield takeEvery(constants.REVIEW_REPORT, reviewReport);
  yield takeEvery(constants.GENERATE_REPORT, generateReport);
}
